import React from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';

import {List} from 'material-ui/List';
import Loader from "../../components/Loader";

import CatalogItem from "./CatalogItem";

class CatalogList extends React.Component {

    constructor() {
        super()
    }

    render() {

        const {
            list, onItemEdit, onItemDelete, isLoading, onDuplicateItem, emptyListMessage, didSearched
        } = this.props;

        return (
            <div>
                <div className="listWrapper">
                    {isLoading && (<Loader/>)}
                    {!isLoading && list && (
                        <List>
                            {list.length === 0 && didSearched && (
                                <div>{emptyListMessage}</div>
                            )}
                            {list.map((item) => (
                                <CatalogItem item={item} onItemEdit={onItemEdit} onItemDelete={onItemDelete} onDuplicateItem={onDuplicateItem}/>))}
                        </List>
                    )}

                </div>
            </div>
        )
    }
}


CatalogList.propTypes = {
    list: PropTypes.array,
    isLoading: PropTypes.bool,
    onItemEdit: PropTypes.func,
    onItemDelete: PropTypes.func,
    onDuplicateItem: PropTypes.func
};

export default CatalogList;